import React from 'react';
import PropTypes from 'prop-types';
import './recordActionBar.scss';

// All available actions stay visible and mounted. Each action can wrap
// independently so narrow viewers never need a horizontally scrolling toolbar.
const RecordActionBar = ({
  primary, secondary, navigation, surface,
}) => (
  <div className={`record-action-bar record-action-bar--${surface}`} role="group" aria-label="Record actions">
    {navigation && <div className="record-action-bar__navigation">{navigation}</div>}
    <div className="record-action-bar__primary">{primary}</div>
    <div className="record-action-bar__secondary">{secondary}</div>
  </div>
);

RecordActionBar.propTypes = {
  primary: PropTypes.node.isRequired,
  secondary: PropTypes.node,
  navigation: PropTypes.node,
  surface: PropTypes.oneOf(['full_page', 'drawer']).isRequired,
};
RecordActionBar.defaultProps = { secondary: null, navigation: null };

export default RecordActionBar;
